export enum MODAL_TYPES {
	NEW_INSURANCE = "NEW_INSURANCE",
	INSURANCE = "INSURANCE",
	FLEX_INSURANCE = "FLEX_INSURANCE",
	FLEX_TERMS_AND_CONDITIONS = "FLEX_TERMS_AND_CONDITIONS",
	CONFIG_SERVICE = "CONFIG_SERVICE",
}
